import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    standalone: false,
})
export class UserProfileComponent implements OnInit, OnDestroy {
    @Input() isExpanded: boolean;
    @Input() displayName: string;
    public isActive = false;
    public isLangMenuActive = false;
    public selectedLang: string = null;

    private readonly authService = inject(AuthService);
    private readonly translateService = inject(TranslateService);
    private logoutSubscription: Subscription;

    logout() {
        this.logoutSubscription = this.authService.logout().subscribe();
    }

    langChange(lang: string) {
        localStorage.setItem('lang', lang);
        this.translateService.use(lang);
        this.isActive = false;
    }

    ngOnInit(): void {
        const storageLang = localStorage.getItem('lang');
        if (storageLang) this.selectedLang = storageLang;
        if (!storageLang) this.selectedLang = 'pl';
    }

    ngOnDestroy(): void {
        if (this.logoutSubscription) {
            this.logoutSubscription.unsubscribe();
        }
    }
}
